export default {
  ORGANIZATIONS_REQUEST_FAILED: 1000,
  ORGANIZATION_NOT_FOUND: 1001,
  LOCATION_NOT_FOUND: 1002,
  BRAND_NOT_FOUND: 1003,
};
